import { z } from 'zod'

export const CreditCardCheckResponse = z.object({
    has_valid_credit_card: z.boolean(),
})

export type CreditCardCheckResponse = z.infer<typeof CreditCardCheckResponse>

export const AddPrivateCardPayload = z.object({
    private_card_number: z.string(),
})
